import styled from 'styled-components';
import { media, Row } from '@simplywallst/ui-core';

import { sectionHeading } from '../../styled';

interface FeatureProps {
  bgColor: string;
}

export const WorkWithUsContainerRow = styled(Row)<FeatureProps>`
  background: ${({ bgColor }) => `${bgColor}`};
  width: 100%;
  background-color: #eaf3ff;
`;

export const WorkWithUsContentRow = styled(Row)`
  margin: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x8spacePx}px 0 ${({ theme }) =>
      theme.x2spacePx}px;
  `}
  img {
    width: 100%;
    margin: ${({ theme }) => theme.x3spacePx}px 0;
    ${media.mdOnly`
      margin-top: ${({ theme }) => theme.x1spacePx}px;
    `}
    ${media.lgUp`
      margin-top: -${({ theme }) => theme.x1spacePx}px;
      max-width: 470px;
    `}
    ${media.xlUp`
      max-width: 600px;
    `}
  }
`;

export const WorkWithUsHeader = styled.h2`
  ${sectionHeading}
  margin: 0 ${({ theme }) => theme.x2spacePx}px ${({ theme }) =>
    theme.x2spacePx}px ${({ theme }) => theme.x1spacePx}px;
  ${media.lgUp`
    margin: 0 ${({ theme }) => theme.x20spacePx}px ${({ theme }) =>
      theme.x2spacePx}px ${({ theme }) => theme.x1spacePx}px;
  `};
`;

export const StyledReactMarkdown = styled('div')`
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGrayRGBA(0.7)};
    padding: 0 ${({ theme }) => theme.x1spacePx}px;
    ${media.lgUp`
      padding: 0 ${({ theme }) => theme.x8spacePx}px 0 ${({ theme }) =>
        theme.x1spacePx}px;
    `}
    strong {
      ${({ theme }) => theme.typography.xLargeStrong};
      color: ${({ theme }) => theme.color.spaceGray};
      line-height: 30px;
      letter-spacing: -0.02em;
    }
  }
  a {
    text-decoration: none;
  }
`;
